import React from 'react';

import styles from '../Filters.module.scss';

import MultiSelectSidebar from '../../multi-select-sidebar/MultiSelectSidebar';
import SingleSelectRadioSidebar from '../../single-select-radio-sidebar/SingleSelectRadioSidebar';
import PageLoader from '../../loader/PageLoader';

import { FindSelectedElement, GetPlanId, GetSelectElements } from '../../../../helpers/Helpers';

import { GetLocationList, UpdateLocationList } from '../../../../api-services/filters.api';

interface Props {
  selection: string;
  history?: any;
  selectedData: any;
  updateSelection: (status) => void;
}

interface State {
  showSidebar: boolean;
  maxLevel: number;
  securityLevel: number;
  locationList: any[];
  selectedLocationList: any[];
  isSaved: boolean;
  isLoading: boolean;
}

export default class LocationFilter extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      showSidebar: false,
      maxLevel: 0,
      securityLevel: 0,
      locationList: [],
      selectedLocationList: !!this.props.selectedData ? this.props.selectedData.levels : [],
      isSaved: !!this.props.selectedData,
      isLoading: false
    };
  }

  getLocationList(dataSource?): void {
    const payload = {
      dimensionName: 'Location',
      maxLevel: this.state.maxLevel,
      levels: dataSource
    };
    const params = {
      userId: sessionStorage.getItem('userName'),
    };

    this.setState({ isLoading: true });
    const apiCall = dataSource === undefined ? GetLocationList(null, params) : GetLocationList(payload, params);

    apiCall
      .then((res: {
        maxLevel: number;
        securityLevel: number;
        levels: any[]
      }) => {
        if (!!res) {
          this.setState({
            maxLevel: res.maxLevel,
            securityLevel: res.securityLevel,
            locationList: res.levels
          }, () => {
            this.setState({
              showSidebar: true,
              isLoading: false
            });
          });
        }
      });
  }

  updateLocationList(dataSource): void {
    const payload = {
      dimensionName: 'Location',
      maxLevel: this.state.maxLevel,
      levels: dataSource
    };

    const params = {
      planId: GetPlanId(this.props.history.location.pathname)
    };

    UpdateLocationList(payload, params)
      .then((res) => {
        if (!!res) {
          this.props.updateSelection(true);
          this.setState({
            showSidebar: false,
            isSaved: true,
            selectedLocationList: dataSource
          });
        }
      });
  }

  recursiveFn(arr): string[] {
    return arr.filter((obj) => obj.selected)
      .reduce((acc, obj) => {
        if (!!!obj.children.length && obj.selected) {
          acc.push(obj.value);
        }
        this.recursiveFn(obj.children || []);
        return acc;
      }, []);
  }

  displaySelectedItem(): any {
    const dataSource = FindSelectedElement(this.state.selectedLocationList, ({ selected }) => selected);
    if (dataSource.length === 0 || !this.state.isSaved) {
      return <span>N/A</span>;
    }

    const selectedLocations: any = GetSelectElements(dataSource, 'location');
    return <span>{selectedLocations.join(', ')}</span>;
  }

  render(): React.ReactNode {
    return (
      <React.Fragment>
        <PageLoader
          status={this.state.isLoading}
          fromFilter={true}
        />
        <p
          className={styles['filter-label']}
          onClick={() => this.getLocationList()}
        >
          Location
        </p>
        <p className={styles['filter-value']}>
          {this.displaySelectedItem()}
        </p>

        {
          this.state.showSidebar && (
            this.props.selection === 'single'
              ? <SingleSelectRadioSidebar
                title="Location"
                dataSource={this.state.locationList}
                lastLevel={this.state.maxLevel}
                securityLevel={this.state.securityLevel}
                onHideSidebar={() => this.setState({ showSidebar: false })}
                onNext={(dataSource) => this.getLocationList(dataSource)}
                onSave={(dataSource) => this.updateLocationList(dataSource)}
              />
              : <MultiSelectSidebar
                title="Location"
                dataSource={this.state.locationList}
                lastLevel={this.state.maxLevel}
                securityLevel={this.state.securityLevel}
                onHideSidebar={() => this.setState({ showSidebar: false })}
                onNext={(dataSource) => this.getLocationList(dataSource)}
                onSave={(dataSource) => this.updateLocationList(dataSource)}
              />
          )
        }

      </React.Fragment>
    );
  }
}
